import type { InterfacePermissions } from '@unifyapps/defs/types/interface';
import { InterfaceModes } from '../../stores/InterfaceStore/types';
import type { UserPermissionsMap } from '../types';

export const hasAccess = (
  currentPermissions: UserPermissionsMap,
  permissionsToAccess: InterfacePermissions | undefined,
  mode: InterfaceModes,
): boolean => {
  // in builder mode, we always want to return true to allow the user to see the form
  if (mode !== InterfaceModes.RUNNER) {
    return true;
  }

  if (!permissionsToAccess) {
    return true;
  }

  for (const groupId in permissionsToAccess) {
    const requiredPermissions = permissionsToAccess[groupId];
    // empty required-permissions list means "no permissions required for this group" —
    // grant regardless of whether the group exists in currentPermissions. This preserves
    // the pre-refactor behavior where the inner for-of just iterated zero times.
    if (!requiredPermissions || requiredPermissions.length === 0) {
      continue;
    }
    const groupPermissions = currentPermissions[groupId];
    if (!groupPermissions) {
      return false;
    }
    for (const permission of requiredPermissions) {
      if (!groupPermissions[permission]) {
        return false;
      }
    }
  }
  return true;
};
